
export const extractEmail = (text) => {
    
    let alphaNumeric = '[a-zA-Z0-9._+-]';
    let alpha = '[a-z]';
    let regexPattern = new RegExp('('+alphaNumeric+'+@'+alpha+'+\\.'+alpha+'+)','gi');
    return text.match(regexPattern);
}